<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'

import { usePlayerSettings } from '@/stores/playerSettings'
import { useGameState } from '@/stores/gameState'

const props = defineProps<{
  value: number
}>()

const { displayMode } = storeToRefs(usePlayerSettings())
const { roomState } = storeToRefs(useGameState())
const formatter = new Intl.NumberFormat('en-US', {
  style: 'decimal',
  maximumFractionDigits: 2
})

const number = computed(() => {
  const bigBlind = roomState.value.gameConfig!.blinds[1]
  return `${formatter.format(
    displayMode.value === 'bb' ? props.value / bigBlind : props.value
  )}${displayMode.value === 'bb' ? ' BB' : ''}`
})
</script>
<template>
  <div>${{ number }}</div>
</template>
